type PollableStatus = "AWAITING_UPLOAD" | "QUEUED" | "PROCESSING" | "COMPLETED" | "FAILED" | "EXPIRED";

export interface PollableJob {
  status: PollableStatus;
  createdAt: string;
  startedAt?: string;
}

const TERMINAL = new Set<PollableStatus>(["COMPLETED", "FAILED", "EXPIRED"]);

/**
 * Poll quickly for normal jobs, then back off and eventually require a manual
 * refresh. This bounds each abandoned browser tab instead of polling forever.
 */
export function nextJobPollInterval(job: PollableJob | undefined, now = Date.now()): number | false {
  if (!job) return 2_500;
  if (TERMINAL.has(job.status)) return false;

  const anchor = job.status === "PROCESSING" && job.startedAt ? job.startedAt : job.createdAt;
  const timestamp = Date.parse(anchor);
  const age = Number.isFinite(timestamp) ? Math.max(0, now - timestamp) : 0;

  if (job.status === "PROCESSING") {
    if (age < 30_000) return 2_500;
    if (age < 2 * 60_000) return 5_000;
    if (age < 10 * 60_000) return 15_000;
    if (age < 30 * 60_000) return 60_000;
    return false;
  }

  if (age < 15_000) return 2_500;
  if (age < 60_000) return 5_000;
  if (age < 5 * 60_000) return 15_000;
  if (age < 15 * 60_000) return 30_000;
  if (age < 30 * 60_000) return 60_000;
  return false;
}

export function automaticPollingStopped(job: PollableJob | undefined, now = Date.now()): boolean {
  return Boolean(job && !TERMINAL.has(job.status) && nextJobPollInterval(job, now) === false);
}
